import { Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { take } from 'rxjs/operators';
import { DropBoxService } from '../drop-box-upload/drop-box.service';

@Component({
  selector: 'sc-drag-and-drop',
  templateUrl: './drag-and-drop.component.html',
  styleUrls: ['./drag-and-drop.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DragAndDropComponent),
      multi: true
    }
  ]
})
export class DragAndDropComponent implements ControlValueAccessor, OnInit, OnChanges {
  @Input() loading: boolean;
  @Input() disabled = false;
  @Input() accept: string;
  @Output() upload = new EventEmitter();
  @Input() fileNumber: number;
  @Input() urls: any = [];
  @Output() urlsChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(private _googleDriveService: DropBoxService) {}

  onChange = url => {};
  onTouched = () => {};
  writeValue(url) {
    this.onChange(url);
  }
  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  uploadFile(filelist: any) {
    this.loading = true;
    this._googleDriveService
      .upload([...filelist])
      .pipe(take(1))
      .subscribe(([file]) => {
        this.urls.push(file.id);
        this.urlsChange.emit(this.urls);
        this.writeValue(file.id);
      });
  }

  ngOnInit() {}

  ngOnChanges() {}
}
